module.exports = __webpack_public_path__ + "static/media/cq_altro_menu.71ffdacd.svg";